// extracted by mini-css-extract-plugin
module.exports = {"mainSpan":"StatusBadge_mainSpan__cUl4s"};